export class UserModel{
    id: number
    user_name: string
    middlename: string
    type: string
    job_title: string
    photo_url: string
    provider: string
    auth_user: []
    group:[]
    permissions: []
}


export class UserResponseModel {
    count: number
    next: string
    previous: string
    results: [UserModel]
}